import { render, staticRenderFns } from "./Database_classification.vue?vue&type=template&id=1cbffff4"
import script from "./Database_classification.vue?vue&type=script&lang=js"
export * from "./Database_classification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports